export default __webpack_public_path__ + "static/26-0ac103e4bdb1c45d2da8737d7a258751.webp";